/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Plugins.FameAdvantage {

    export class ImportResultController {
        static $inject = [
            '$mdDialog',
            'meevo.components.short-cuts.ShortCutsService',
        ];

        public items: IImportResult;
        public statuses = {
            [ImportResultEnum.Successful]: {
                label: 'LABEL_SUCCESSFUL',
                className: 'color-green',
            },
            [ImportResultEnum.Updated]: {
                label: 'LABEL_UPDATED',
                className: 'color-green',
            },
            [ImportResultEnum.Failed]: {
                label: 'LABEL_FAILED',
                className: 'color-red',
            }
        };

        private shortCutGroup: IShortCutGroup;

        constructor(private $mdDialog: ng.material.IDialogService,
                    private shortCutsService: Meevo.Components.ShortCuts.IShortCutsService) {
            this.configureShortCuts();
            this.shortCutsService.activateGroup(this.shortCutGroup);
        }


        public cancel(): void {
            this.$mdDialog.cancel();
            this.shortCutsService.deactivateGroup(this.shortCutGroup);
        }

        private configureShortCuts() {
            this.shortCutGroup = new ShortCutGroup([
                {
                    shortCutName: 'MODAL_OK_BUTTON',
                    callback: (event: Event, hotkey: ng.hotkeys.Hotkey) => {
                        event.preventDefault();

                        this.cancel();
                    }
                }
            ], {
                groupLevel: Components.ShortCuts.GroupLevels.Modal,
                deactivateGlobal: true,
            });
        }
    }

    angular.module('meevo.plugins.fameAdvantage')
        .controller('meevo.plugins.fameAdvantage.ImportResultController', ImportResultController);
}
